import{createTheme as r}from"@mui/material/styles";import{base as e}from"./base";const o=r({...e,palette:{...e.palette,mode:"dark",background:{default:"#141414",paper:"#000000"}}});export{o as dark};
//# sourceMappingURL=dark.js.map
